import React, { useLayoutEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { Icon, Textarea, Div, Text } from '@pinpoint/design-kit';

import { APP } from 'src/store/ActionTypes';

import BaseDialog from './base';

export function FeedbackDialog({ isOpen, actions }) {
  const defaultValues = {
    feedback: '',
  };

  const { errors, control, handleSubmit } = useForm({ defaultValues });
  const onSubmit = (data) => {
    actions.handlers[0].on({
      type: APP.SUBMIT_FEEDBACK,
      payload: { page: 'Copy Personalization', ...data },
    });
    actions.close.on();
  };

  const formSubmit = handleSubmit(onSubmit);

  useLayoutEffect(() => {
    ReactTooltip.rebuild();
  });

  return (
    <BaseDialog
      isOpen={isOpen}
      actions={{
        ...actions,
        handlers: [
          {
            on: formSubmit,
          },
        ],
      }}
      title={{
        text: 'Loving Our Product?',
        backgroundColor: 'brand600',
        color: 'white',
        textSize: 'title',
        icon: <Icon name="Feedback" color="white" size="3.125rem" m={{ r: '1rem' }} />,
      }}
      items={{
        buttons: [
          {
            text: 'SUBMIT',
            textSize: 'body',
            close: false,
            form: true,
          },
        ],
        content: [
          <Div d="flex" flexDir="column">
            <Text textSize="input" textWeight="500" textColor="shade66">
              Please send us your comments and suggestions.
            </Text>
            <Controller
              name="feedback"
              as={Textarea}
              rounded="md"
              m={{ t: '.875rem' }}
              h="8.75rem"
              borderColor="shade66"
              control={control}
              rules={{
                required: 'Feedback is required',
              }}
            />
            <Text textColor="danger800" textSize="caption" m={{ t: '.125rem' }}>
              <ErrorMessage errors={errors} name="feedback" />
            </Text>
          </Div>,
        ],
      }}
    />
  );
}

FeedbackDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    cancel: PropTypes.shape({
      before: PropTypes.func,
      on: PropTypes.func.isRequired,
      after: PropTypes.func,
    }).isRequired,
    close: PropTypes.shape({
      before: PropTypes.func,
      on: PropTypes.func.isRequired,
      after: PropTypes.func,
    }).isRequired,
    handlers: PropTypes.arrayOf(
      PropTypes.shape({
        before: PropTypes.func,
        on: PropTypes.func.isRequired,
        after: PropTypes.func,
      })
    ),
  }).isRequired,
  // eslint-disable-next-line react/require-default-props
  title: PropTypes.shape({
    text: PropTypes.string.isRequired,
    textSize: PropTypes.string,
    backgroundColor: PropTypes.string.isRequired,
    color: PropTypes.string,
  }),
  items: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.element).isRequired,
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        textSize: PropTypes.string,
        close: PropTypes.bool.isRequired,
      }).isRequired
    ),
  }).isRequired,
};

export default FeedbackDialog;
